export const FoodList = ({ foods, showCarbs = false }) => (
  <ul className="flex flex-col divide-y divide-border" data-testid="food-list">
    {foods.map((f, i) => (
      <li key={i} className="flex items-center justify-between gap-3 py-3" data-testid={`food-item-${i}`}>
        <div className="min-w-0">
          <p className="text-base font-semibold text-foreground">{f.name}</p>
          {f.portion && <p className="text-sm text-muted-foreground">{f.portion}</p>}
        </div>
        {showCarbs && f.carbs_g != null && (
          <span className="shrink-0 text-lg font-bold text-primary whitespace-nowrap">{f.carbs_g} g</span>
        )}
      </li>
    ))}
  </ul>
);
